export default "/service-worker.js";